import styled from '@emotion/styled';
import React from 'react';
import { useFormContext } from './FormContext';

const ResultsWrapper = styled.div`
  width: 180px;
  height: 100vh;
  border-right: 1px solid #e5e5ea;
  padding: 30px;
  position: fixed;
  margin-left: 60px;
  background-color: #fff;
  z-index: 10;
  padding-top: 50px;

  @media (max-width: 1024px) {
    width: 140px;
    padding: 20px;
    margin-left: 60px;
  }

  @media (max-width: 768px) {
    width: 100px;
    padding: 15px;
  }

  @media (max-width: 480px) {
    width: 70px;
    padding: 10px;
  }
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
`;

const navItem = {
  margin: '20px 0',
  // cursor: 'pointer',
  color: '#808080',
  pointerEvents: 'none' as React.CSSProperties['pointerEvents'],
  
};
const activeNavItem = {
  margin: '20px 0',
  // cursor: 'pointer',
  fontWeight: 'bold',
  color: '#00b8d4',
  pointerEvents: 'none' as React.CSSProperties['pointerEvents'],
};
const SidebarTitle = styled.h2`
  margin: 0 0 20px 0;
  font-size: 16px;
  font-weight: bold;
  color: #090928;
  border-bottom: 1px solid #e5e5ea;
  padding-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const Sidebar = () => {
  const { setActiveTab, activeTab } = useFormContext();

  const handleTabClick = (tab: string) => {
    setActiveTab(tab); 
  };
  return (
    <ResultsWrapper>
<SidebarTitle>Customer Registration</SidebarTitle>
      <NavList>
        <li
          style={activeTab === 'business-info' ? activeNavItem : navItem}
          onClick={() => handleTabClick('business-info')}
        >
          Business Info
        </li>
        <li
          style={activeTab === 'shipping-info' ? activeNavItem : navItem}
          onClick={() => handleTabClick('shipping-info')}
        >
          Shipping Info
        </li>
        <li
          style={activeTab === 'billing-info' ? activeNavItem : navItem}
          onClick={() => handleTabClick('billing-info')}
        >
          Billing Info
        </li>
        <li
          style={activeTab === 'contacts' ? activeNavItem : navItem}
          onClick={() => handleTabClick('contacts')}
        >
          Contacts
        </li>
     
      </NavList>
    </ResultsWrapper>
  );
};

export default Sidebar;
